import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';
import useService from '../../../useService';
import { dehydrateFormData } from '../../utils/formDataParser';
import { TSubmitAssetData } from '../../utils/types';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const { requestCreateAsset } = useService();

	const createAsset = (createdData: TSubmitAssetData) => {
		setShowLoader(true);
		requestCreateAsset(app.appName, createdData).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occurred while uploading the asset', { type: 'error' });
					setShowLoader(false);
					return;
				}

				showAlert('Asset created');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: TSubmitAssetData) => {
		createAsset(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: EMPTY_OBJECT, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
